import { getImageProps } from "next/image"

/**
 * Above-the-fold image with mobile/desktop art direction.
 *
 * Renders a single <picture> so the browser only downloads the variant matching
 * the viewport, straight from the SSR HTML (no JS media query, no hydration swap).
 * `priority` marks the LCP candidate: eager + fetchpriority=high.
 *
 * Uses `fill`: the parent must be positioned and sized.
 */
export const HeroPicture = ({
	desktop,
	mobile = null,
	alt = "",
	desktopMedia = "(min-width: 768px)",
	sizes = "100vw",
	priority = false,
	className = "object-cover",
}) => {
	if (!desktop && !mobile) return null

	const common = {
		alt,
		fill: true,
		sizes,
		className,
		loading: priority ? "eager" : "lazy",
		...(priority ? { fetchPriority: "high" } : {}),
	}

	const {
		props: { srcSet: desktopSrcSet },
	} = getImageProps({ ...common, src: desktop || mobile })
	const {
		props: { srcSet: mobileSrcSet, ...imgProps },
	} = getImageProps({ ...common, src: mobile || desktop })

	return (
		<picture>
			{mobile && desktop && (
				<source media={desktopMedia} srcSet={desktopSrcSet} sizes={sizes} />
			)}
			<img {...imgProps} alt={alt} srcSet={mobileSrcSet} />
		</picture>
	)
}
